module.exports = require('./helpers/bundle-url').getBundleURL('8SseS') + "termsofservice_modalimage.2627690a.png";